var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.84 392.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,293.62v54.11a45.14,45.14,0,0,0,45.08,45.08H379.76a45.13,45.13,0,0,0,45.08-45.08V45.08A45.14,45.14,0,0,0,379.76,0H45.08A45.13,45.13,0,0,0,0,45.08H0V273.62M379.76,20a25.11,25.11,0,0,1,25.08,25.08V312.93L277.39,168.85a10,10,0,0,0-15,0l-68.36,77.28L145.47,193.7a10,10,0,0,0-14.67,0L20,313.29V45.08A25.11,25.11,0,0,1,45.08,20Zm-199,241.18-49.86,56.37H43.31l94.83-102.33Zm199,111.63H45.08A25.11,25.11,0,0,1,20,347.73V337.55H236.87a10,10,0,1,0,0-20h-79.3l112.33-127,112.33,127h-55a10,10,0,0,0,0,20h77.56v10.17a25.11,25.11,0,0,1-25.08,25.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,337.55a10,10,0,1,1,9.79-8,10.07,10.07,0,0,1-9.79,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,160.22a53,53,0,1,1,53-53A53.08,53.08,0,0,1,174.76,160.22Zm0-86.06a33,33,0,1,0,33,33A33.06,33.06,0,0,0,174.76,74.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenders);
export default __webpack_public_path__ + "static/media/renders.1b232f8233770648102ec8209c89f938.svg";
export { ForwardRef as ReactComponent };